module.exports = __webpack_public_path__ + "img/phone_forwarded.ad88e507.svg";